import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/services';
import { map } from 'rxjs';

import { Landscape, LANDSCAPES } from '../../models/landscape';
import { WorldRegion, WORLD_REGIONS } from '../../models/world-region';
import { Store } from '../../../../shared/store';
import { RegionAndLandscapeState } from './region-and-landscape.state';

const regionAndLandscapeState = new RegionAndLandscapeState();

@Injectable({ providedIn: 'root' })
export class RegionAndLandscapeStore extends Store<RegionAndLandscapeState> {
  regions$ = this.state$.pipe(map((s) => s.regions));
  landscapes$ = this.state$.pipe(map((s) => s.landscapes));

  constructor(
    private languageService: LanguageService,
    private translateService: TranslateService
  ) {
    super(regionAndLandscapeState);
    this.languageService.currentLanguage$.subscribe(() => {
      regionAndLandscapeState.regions =
        this.sortRegionsOrLandscapesByTranslatedNames('region', WORLD_REGIONS);
      regionAndLandscapeState.landscapes =
        this.sortRegionsOrLandscapesByTranslatedNames('landscape', LANDSCAPES);
    });
  }

  private sortRegionsOrLandscapesByTranslatedNames(
    itemType: 'region' | 'landscape',
    items: WorldRegion[] | Landscape[]
  ): any[] {
    const key: string = itemType === 'region' ? 'regions' : 'landscapes';

    return items.sort((item1, item2) => {
      return this.translateService
        .instant(`browse.landscapesAndRegions.${key}.${item1.name}`)
        .toLowerCase()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '') <
        this.translateService
          .instant(`browse.landscapesAndRegions.${key}.${item2.name}`)
          .toLowerCase()
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
        ? -1
        : +1;
    });
  }
}
